import { $ } from "../third-party-imports";

let redirectTimeout: number | null = null;

function isCAWebSite(): boolean{
    const currentUrl = new URL(window.location.href);
    let domainName = currentUrl.hostname.toLowerCase();
    const pathSegments = currentUrl.pathname.split('/').filter(Boolean);
    return domainName.endsWith(".ca") || pathSegments[0] === "ca";
}

function redirectHelper(destination: string, postal: string): void{
    $('.redirect-validation-message').removeClass('hidden');
    $(document).off("click.bs.modal.data-api", '[data-toggle="modal"]');
    redirectTimeout = window.setTimeout(() =>
    {
        sessionStorage.setItem('redirectZip', postal);
        window.location.href = `https://${destination}`;
    }, 5000);
}

export function redirectZipCode(postal: string): boolean
{
    if (redirectTimeout !== null)
    {
        return false;
    }
    $('.redirect-validation-message').addClass('hidden');
    const nblyUSDomain = window.location.hostname;
    const nblyCADomain = nblyUSDomain + "/ca";
    const caZipRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    const usZipRegex = /^(\d{5}(-\d{4})?)$/;
    const isCA = isCAWebSite();

    if ( isCA && usZipRegex.test(postal))
    {
        redirectHelper(nblyUSDomain, postal);
        return false;
    }

    if (!isCA && caZipRegex.test(postal))
    {
        redirectHelper(nblyCADomain, postal);
        return false;
    }

    return true;
}

// Call this function on "Stay on Page" button click
export function cancelRedirect()
{
    if (redirectTimeout !== null)
    {
        window.clearTimeout(redirectTimeout);
        redirectTimeout = null;
    }
}

document.addEventListener("DOMContentLoaded", () =>
{
    $('.redirect-validation-message a').on('click', function (e) {
        e.preventDefault(); // Prevent the link from navigating
        cancelRedirect();
    });
});


